const resources = {
    viewAllBenefits: 'View all benefits',
    faqs: 'FAQs',
    pointsTitle: 'Earn points',
    pointsDescription: 'Earn points on eligible purchases.',
    birthdayGiftTitle: 'Birthday gift',
    birthdayGiftDescription: 'Choose a gift during your birthday month.',
    freeShippingTitle: 'Free standard shipping',
    freeShippingDescription: 'Get free standard shipping on eligible orders.',
    savingsEventsTitle: 'Seasonal savings events',
    savingsEventsDescription: 'Access Beauty Insider savings throughout the year.',
    experiencesTitle: 'Exclusive experiences',
    experiencesDescription: 'Get access to member-only events and experiences.',
    vibSavingsTitle: 'VIB savings',
    vibSavingsDescription: 'Unlock VIB access during seasonal savings events.',
    rougeSavingsTitle: 'Rouge savings',
    rougeSavingsDescription: 'Unlock Rouge access during seasonal savings events.',
    earlyAccessTitle: 'Early access',
    earlyAccessDescription: 'Shop select launches and events early.',
    featuredBenefitsTitle: 'Featured Benefits',
    featuredBenefitsAsInsiderTitle: 'Featured Benefits as Insider',
    featuredBenefitsAsVibTitle: 'Featured Benefits as VIB',
    featuredBenefitsAsRougeTitle: 'Featured Benefits as Rouge',
    featuredJoinPoints: 'Earn points on every purchase',
    featuredInsiderDiscount: 'Member-only savings events',
    featuredVibDiscount: '15% off member-only discount twice a year',
    featuredRougeDiscount: '20% off member only discount twice a year',
    featuredPoints: 'Points on your purchase every time',
    featuredVibPoints: '3x points on your purchase twice a year',
    featuredRougePoints: '4x points on your purchase twice a year',
    featuredFirstAccess: 'First access to new releases',
    featuredExclusiveGift: 'Exclusive gift with purchase',
    featuredFreeShipping: 'Free standard shipping',
    featuredFreeShippingEveryTime: 'Free standard shipping every time',
    featuredBirthdayGift: 'Free birthday gift',
    featuredBirthdayGiftSet: 'Free birthday gift set',
    featuredPointsSavingsExperiences: 'Points = savings and experiences',
    nonBiTitle: 'Beauty Insider benefits',
    nonBiSubtitle: 'Join Beauty Insider to unlock points, birthday gifts, free shipping, and exclusive savings.',
    insiderTitle: 'Insider benefits',
    insiderSubtitle: 'Your Beauty Insider membership includes points, birthday gifts, and member-only savings.',
    vibTitle: 'VIB benefits',
    vibSubtitle: 'Your VIB status includes Insider perks plus upgraded savings and events.',
    rougeTitle: 'Rouge benefits',
    rougeSubtitle: 'Your Rouge status includes the highest Beauty Insider savings and exclusive experiences.',
    whenYouReachVib: 'When You Reach VIB',
    whenYouReachVibDescription: 'Keep earning toward VIB status for upgraded Beauty Insider savings and experiences.',
    whenYouReachRouge: 'When You Reach Rouge',
    whenYouReachRougeDescription: 'Keep earning toward Rouge status for the highest Beauty Insider savings and exclusive experiences.',
    creditCardHolderTitle: 'Your Benefit as Sephora Credit Card Holder',
    creditCardHolderEarnRewards: 'Earn 4% back in credit card rewards²',
    creditCardHolderEarnPoints: 'Earn 2 points per $1 spent¹',
    creditCardHolderFirstPurchase: '25% off your first Sephora purchase¹',
    creditCardHolderCta: 'View Your Card Details'
};

export default function getResource(label) {
    return resources[label];
}
